import Vue from 'vue';
import sys from '@/services/system';

const sourceData = {
    "groups": [
        {
            'name': "default",
            "label": "",
            "order": 0
        },
        {
            'name': "MonthlyAmountWithoutMeteringDevices",
            "label": "Ежемесячная_сумма_платежей_при_отсутствии_приборов_учета_(с_НДС)",
            "order": 1        
        }
    ],
	"fields": {
		"IsTypicalForm": { "label": "Типовой", "componentName": "v-field-edit-bool", "value": true, "group": "default", "order": 1 },
        "AgreementNumber": {"label": "Номер_соглашения", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 2 },
        "AgreementDate": {"label": "Дата_соглашения", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 3 },
		"ContractNumber": { "label": "Номер_договора", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 4 },
		"ContractDate": { "label": "Дата_договора", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 5 },
        
        "PlaceContractKZ": {"label": '{"label":"Место_заключения_договора","lang":"KZ"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 6},
        "PlaceContractRU": {"label": '{"label":"Место_заключения_договора","lang":"RU"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 7},
        "DeclarantYurAddressKZ": {"label": '{"label":"Юр_адрес_заявителя","lang":"KZ"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 8},
        "DeclarantYurAddressRU": {"label": '{"label":"Юр_адрес_заявителя","lang":"RU"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 9},

        "ContractNumberWithGA": { "label": "Номер_договора_заключенного_с_ГУ", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 10 },
		"ContractDateWithGA": { "label": "Дата_договора_заключенного_с_ГУ", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 11 },

        "ContractBeginDate": { "label": "Дата_начала_действия_договора", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 12 },	
		"ContractEndDate": { "label": "Дата_окончания_действия_договора", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 13 },	

        "Provisioner": { "label": "Поставщик", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 14 },
		
		"ProvisionServicesDate": { "label": "Дата_фактического_предоставления_услуг", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 15 },

		"AddressObjectKZ": { "label": '{"label":"Адрес_объекта","lang":"KZ"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 16 },
        "AddressObjectRU": { "label": '{"label":"Адрес_объекта","lang":"RU"}', "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 17 },

        "AllowedVolumeOfDrinkingWater": { "label": "Разрешенный_объем_питьевой_воды,_куб.м_/год", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 18 },		
		"AllowedVolumeOfTechnicalWater": { "label": "Разрешенный_объем_технической_воды,_куб.м_/год", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 19 },
		"DistributedWasteWater": { "label": "Производственные_сточные_воды,_куб.м_/год", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 20 },

		"ForServicesProvided": { "label": "за_предоставляемые_услуги,_тенге", "componentName": "v-field-edit-number", "value": null, "group": "MonthlyAmountWithoutMeteringDevices", "order": 21},
		"MonthlyAmountForWaterSupply": { "label": "за_водоснабжение,_тенге_куб.м_/мес", "componentName": "v-field-edit-number", "value": null, "group": "MonthlyAmountWithoutMeteringDevices", "order": 22 },
		"MonthlyAmountForWaterDisposal": { "label": "за_водоотведение,_тенге_куб.м_/мес", "componentName": "v-field-edit-number", "value": null, "group": "MonthlyAmountWithoutMeteringDevices", "order": 23 },
		
        "RateAccumulationMunicipalWaste": { "label": "Норма_накопления_ком.отходов,_куб.м_в_год_на_1_чел.", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 24 },

		"CostServicesPersonPerMonth": { "label": "Стоимость_услуг_за_1_чел._в_месяц,_тенге", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 25 },
        "UsableArea": { "label": "Полезная_площадь_кв_м.", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 26 },
		"NumberOfResidence": { "label": "Количество_проживающих_лиц,_чел.", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 27 },

		"NameDocumentForObject": { "label": "Наименование_правоустанавливающего_документа_на_объект", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 28 },
		"NumberDocumentForObject": { "label": "Номер_правоустанавливающего_документа_на_объект", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 29 },
		"DateDocumentForObject": { "label": "Дата_правоустанавливающего_документа_на_объект", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 30 },
		"TotalAreaOfObject": { "label": "Общая_площадь_объекта,_кв.м", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 31 },

        "DesignLoadGcalh": { "label": "Проектная_нагрузка_Гкал_час", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 32 },
        "HotWaterConsumptiontonsmonth": { "label": "Расход_горячей_воды_тонн_мес", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 33 }, 
        "WaterLeakageRatetonsmonth": { "label": "Норма_утечки_воды_тонн_мес", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 34 },

        "ContractNumberHCS": { "label": "Номер_договора_об_оказании_ЖКУ", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 1 },
        "ContractDateHCS": { "label": "Дата_заключения_договора_об_оказании_ЖКУ", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 2 },
        "ContractNumberMaintenance": { "label": "Номер_договора_ТО", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 3 },
        "ContractDateMaintenance": { "label": "Дата_заключения_договора_ТО", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 4 },
        "ConsumerType": { "label": "Тип_потребителя", "componentName": "v-field-edit-select", "value": null, "reference": "ConsumerType",  "group": "default", "order": 11 },
        "DateAttachmentMaintenanceAgreement": { "label": "Дата_приложения_к_договору_ТО", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 12 },
        "NameOfGasConsumingSystems": { "label": "Наименование_газопотребляющих_систем", "componentName": "v-field-edit-select", "value": null, "reference": "NameOfGasConsumingSystems",  "group": "default", "order": 13 },
        "CostOfSolidWasteRemovalServices": { "label": "Стоимость_услуг_по_вывозу_ТБО_м3_тенге", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 23 },
        "AccumulationOfSolidWastePerYear": { "label": "Накопление_ТБО_м3_в_год", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 34 },
        "MonthlyVolumeOfSolidWaste": { "label": "Месячный_объем_ТБОм3 ", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 35 },
        "MonthlyAmountPaid": { "label": "Ежемесячная_сумма_к_оплате_тенге", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 36 },
        "NumberOfContainers": { "label": "Количество_контейнеров_штук", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 37 },
        "FrequencyOfGarbageCollection": { "label": "Периодичность_вывоза_раз_в_неделю", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 38 },
        
        "AccountNumber": {"label": "Лицевой_счет", "componentName": "v-field-edit-number", "value": null, "group": "default", "order": 39 },
        "ObjectName": {"label": "Наименование_объекта", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 40 },
        "NameOfEngineer": { "label": "ФИО_инженера", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 41 },
        
        "PreviousName": {"label": "Прежнее_наименование_организации_потребителя", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 44 },
        "Heating": { "label": "Отопление_Гкал/ч", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 45 },
        "Ventilation": {"label": "Вентиляция_Гкал/час", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 46 },
        "HWS": { "label": "ГВС_Гкал/ч", "componentName": "v-field-edit-text", "value": null, "group": "default", "order": 47 },
        "CalculationDate": {"label": "Дата_расчета", "componentName": "v-field-edit-date", "value": null, "group": "default", "order": 48 }
	},	
	"serviceCodes": {
        "01110001": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate",
                "AddressObjectKZ",
                "AddressObjectRU"
			]		
		},
		"01050008": {
			"fields": [ 				
				"ContractNumber", 
				"ContractDate",
                "ContractBeginDate",
                "ContractEndDate",                
                "AddressObjectKZ",
                "AddressObjectRU",
                "AllowedVolumeOfDrinkingWater",
                "AllowedVolumeOfTechnicalWater",
                "DistributedWasteWater",
			]		
		},
		"01050009": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate",
			
				"ProvisionServicesDate",
				"AddressObjectKZ",
                "AddressObjectRU",
				"AllowedVolumeOfDrinkingWater",		
				"AllowedVolumeOfTechnicalWater",
				"DistributedWasteWater",
				"ForServicesProvided",
				"MonthlyAmountForWaterSupply",
				"MonthlyAmountForWaterDisposal"
			]
		},
		"01100010": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate" 
			]	
		},
		"01050012": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate",
			
				"ProvisionServicesDate",
				"AddressObjectKZ",
                "AddressObjectRU",
				"AllowedVolumeOfDrinkingWater",		
				"AllowedVolumeOfTechnicalWater",
				"DistributedWasteWater",
				"ForServicesProvided",
				"MonthlyAmountForWaterSupply",
				"MonthlyAmountForWaterDisposal"
			]
		},
		"01100008": {
			"fields": [ 
                "IsTypicalForm", 
                "ContractNumber", 
                "ContractDate", 
                "ContractEndDate" 
            ]	
		},
		"01100005": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate", 
                "Provisioner",
				
				"ContractEndDate", 
				
				"AddressObjectKZ",
                "AddressObjectRU", 
				"NameDocumentForObject", 
				"NumberDocumentForObject", 
				"DateDocumentForObject", 
				"TotalAreaOfObject"
			]	
		},
		"01100006": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate", 
                "Provisioner",
				
				"ContractEndDate", 
				
				"AddressObjectKZ",
                "AddressObjectRU", 
				"NameDocumentForObject", 
				"NumberDocumentForObject", 
				"DateDocumentForObject", 
				"TotalAreaOfObject"
			]			
		},
		"01100012": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate", 
				
				"AddressObjectKZ",
                "AddressObjectRU", 
				"NameDocumentForObject", 
				"NumberDocumentForObject", 
				"DateDocumentForObject", 
				"TotalAreaOfObject"
			]			
		},
		"01100013": {
			"fields": [ 
				"IsTypicalForm", 
				"ContractNumber", 
				"ContractDate", 
				
				"AddressObjectKZ",
                "AddressObjectRU", 
				"NameDocumentForObject", 
				"NumberDocumentForObject", 
				"DateDocumentForObject", 
				"TotalAreaOfObject"
			]		
		},
        "10010001": {
            "fields": [ 
                "ContractNumber",
                "ContractDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "RateAccumulationMunicipalWaste",
                "NumberOfResidence"
			]	
        },  
        "10020001": {
            "fields": [ 
                "ContractNumber",
                "ContractDate",
                // "ContractBeginDate",
                // "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                // "AllowedVolumeOfDrinkingWater",		
                // "AllowedVolumeOfTechnicalWater",
                // "DistributedWasteWater"
			]	
        },  
        "10030001": {
            "fields": [ 
                "ContractNumber",
                "ContractDate",                
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "UsableArea",
                "NumberOfResidence",                
                "DesignLoadGcalh",
                "HotWaterConsumptiontonsmonth", 
                "WaterLeakageRatetonsmonth"
			]	
        },
        "06030001": {
            "fields": [ 
                //"ContractNumberHCS",
                "ContractDateHCS",
                //"ContractNumberMaintenance",
                "ContractDateMaintenance",
                "AddressObjectKZ",
                "AddressObjectRU",
                "ConsumerType",
                "DateAttachmentMaintenanceAgreement",
                "NameOfGasConsumingSystems"
			]	
        },
        /*"06050001": {
            "fields": [                 
                "ContractDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "UsableArea",
                "NumberOfResidence"
			]	
        },*/   
        "15030003": {
            "fields": [
                "ContractNumber",
                "ContractDate",
                "CostServicesPersonPerMonth",
                "ContractBeginDate",
                "AddressObjectKZ",
                "AddressObjectRU"
            ]
        },
        "01170001": {
            "fields": [
                "ContractNumber",
                "ContractDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "CostServicesPersonPerMonth",
                "NumberOfResidence"
            ]
        },
        "01170002":{
            "fields": [
                "ContractNumber",
                "ContractDate",
                "ContractBeginDate",
                "AddressObjectKZ",
                "AddressObjectRU",                
                "CostOfSolidWasteRemovalServices",
                "AccumulationOfSolidWastePerYear",
                "MonthlyVolumeOfSolidWaste",
                "MonthlyAmountPaid"
            ]
        },
        "01180001":{
            "fields": [
                "ContractNumber",
                "ContractDate",
                "ContractNumberWithGA",
                "ContractDateWithGA",                
                "AddressObjectKZ",
                "AddressObjectRU",  
                "CostServicesPersonPerMonth",
                "NumberOfResidence"
            ]
        },
        "01180003":{
            "fields": [
                "ContractNumber",
                "ContractDate",
                "ContractBeginDate",
                "AddressObjectKZ",
                "AddressObjectRU",                
                "CostOfSolidWasteRemovalServices",
                "AccumulationOfSolidWastePerYear",
                "MonthlyVolumeOfSolidWaste",
                "MonthlyAmountPaid"
            ]
        },
        "06060002": {
			"fields": [ 
                "ContractNumber", 
                "ContractDate", 
                "AddressObjectKZ",
                "AddressObjectRU",
            ]
		},
        "01040047":{
            "fields": [
                "AgreementNumber",
                "AgreementDate",
                "ContractNumber", 
                "ContractDate",
                "PreviousName"
            ]
        },
        "01040048":{
            "fields": [
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU"
            ]
        },
        "01040049":{
            "fields": [
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU" 
            ]
        },
        "01040050":{
            "fields": [
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "Heating",
                "HWS",
                "NameOfEngineer"
            ]
        },
        "01040051":{
            "fields": [
                "ContractNumber", 
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU" 
            ]
        },
        "01040051_":{
            "fields": [
                "ContractNumber", 
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AccountNumber",
                "ObjectName",
                "AddressObjectKZ",
                "AddressObjectRU",
                "Heating",
                "Ventilation",
                "HWS",
                "CalculationDate"
            ]
        },
        "01040052":{
            "fields": [
                "ContractNumber", 
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AddressObjectKZ",
                "AddressObjectRU" 
            ]
        },
        "01040052_":{
            "fields": [
                "ContractNumber", 
                "ContractDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractEndDate",
                "AccountNumber",
                "ObjectName",
                "AddressObjectKZ",
                "AddressObjectRU",
                "Heating",
                "Ventilation",
                "HWS",
                "CalculationDate" 
            ]
        },
        "01040053":{
            "fields": [
                "AgreementNumber",
                "AgreementDate",
                "PlaceContractKZ",
                "PlaceContractRU",
                "ContractNumber", 
                "ContractDate",
                "AccountNumber",
                "ObjectName",
                "AddressObjectKZ",
                "AddressObjectRU",
                "Heating",
                "Ventilation",
                "HWS",
                "CalculationDate" 
            ]
        },
        "06090002": {
            "fields": [
                "ContractDate",
                "AddressObjectKZ",
                "AddressObjectRU",
                "UsableArea",
                "NumberOfResidence",
                "ContractEndDate"
            ]
        }
	}
};

const cscContractInfo = {
    namespaced: true,
    state: {
        isPending: false,
        isVisible: false,

        resolve: null,
        reject: null,

        dataSource: null,
        serviceCode: null,
        key: ""
    },
    mutations: {
        SET_IS_PENDING(state, payload) {
            state.isPending = payload;
        },
        SET_IS_VISIBLE(state, payload) {
            state.isVisible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },  
        SET_DATASOURCE(state, payload) {
            state.dataSource = payload;            
        },
        SET_KEY(state, payload) {
          state.key = payload;  
        },
        SET_SERVICECODE(state, payload){
            state.serviceCode = payload;
        },
        UPDATE_DATASOURCE(state, payload) {     
            
            if (!this._vm.$_.has(state.dataSource, payload.property)) 
                Vue.set(state.dataSource, payload.property, payload.value)
            else
                this._vm.$_.set(state.dataSource, payload.property, payload.value)
        },
    },
    actions: {
        async open({ commit }, serviceInfo) {

            if (!Object.prototype.hasOwnProperty.call(sourceData.serviceCodes, serviceInfo.serviceCode))
            {
                this._vm.$notify.alert(`Для услуги с кодом - ${serviceInfo.serviceCode} не определены свойства.`);
                return;
            }
            if (['01040051', '01040052'].includes(serviceInfo.serviceCode)){
                if (serviceInfo.declarantType != 1)
                    serviceInfo.serviceCode = `${serviceInfo.serviceCode}_`;
            }
            let dataSource = this._vm.$_.orderBy(
                this._vm.$_(sourceData.serviceCodes[serviceInfo.serviceCode].fields.map(f => ({name: f, field: JSON.parse(JSON.stringify(sourceData.fields[f])) }) ))
                    .groupBy('field.group')
                    .map((value, key) => ({ group: sourceData.groups.find(g => g.name == key), values: this._vm.$_.orderBy(value, ['field.order'], ['asc']) }))
                    .value(), 
                ['group.order'], ['asc']
            );
            
            commit('SET_KEY', sys.generateUUID());
            commit('SET_DATASOURCE',dataSource);
            commit('SET_SERVICECODE', serviceInfo.serviceCode);
            commit('SET_IS_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state, rootGetters }) {
            commit('SET_IS_VISIBLE', false);
            
            let result = {
                DocumentId: rootGetters['global/actionsource/getDataSource'].Data.Object.Document.id,                           
            };

            state.dataSource.forEach(e => {
                e.values.forEach(v => {
                    result[v.name] = v.field.value;
                })
            });

            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_IS_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
        updateDataSource({ commit }, data) {
            commit('UPDATE_DATASOURCE', data);
        },
    },
    getters: {
        isPending: (s) => s.isPending,
        isVisible: (s) => s.isVisible,
        
        isValid: (s) => s.dataSource.some(e => !e.values.some(v => !(typeof(v.field.value) === 'boolean' || !!v.field.value) )),
        dataSource: (s) => s.dataSource,
        skey: (s) => s.key,
        serviceCode: (s) => s.serviceCode,
    }
}

export default cscContractInfo;